
import { mapState, mapActions, mapMutations } from 'vuex'
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XNumber from 'vux/src/components/x-number/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'

import questionIcon from 'assets/icons/icon-customer-service@3x.png'
import iconKefu from 'assets/icons/icon_kefu1@3x.png'
import isValid from '../../utils/validor'
import editIcon from 'assets/icons/icon_pen_edit@3x.png'
import meiqia from '../../utils/meiqia'
import { showLoading, closeLoading } from '../../../static/loading.js'

export default {
name: 'SportsTourPackageConfirm2',
components: {
XHeader,
XNumber,
XInput,
Datetime,
Group,
Checker,
CheckerItem,
XButton,
XTextarea,
showLoading,
closeLoading,
},
data() {
return {
timeselectdivshow: false,
questionIcon,
iconKefu,
editIcon,
userId: this.$jwt.userId,
sleletedTravelers: [],
sleletedTravelers_new: [],
travelers: [],
initTourOrderData: {
tourId: 0,
personCount: 1,
contactInfo: {
id: '',
name: null,
mobile: null,
},
},


minCount: 1,
}
},
watch: {
sportsTourRoute() {
this.$nextTick(() => {
if (window.sessionStorage.getItem(`${this.userId + window.sessionStorage.getItem('routeId')}startTime`) !== null) {
this.timetabclick(window.sessionStorage.getItem(`${this.userId + window.sessionStorage.getItem('routeId')}startTime`))
} else {
this.timetabclick(0)
}
})
},
},
computed: {
...mapState({
sportsTourRoute: ({ sportsTour }) => sportsTour.sportsTourRoute,
attn: ({ attn }) => attn.commonAttn,
tourOrderData: ({ order }) => order.tourOrderData,
}),
expectPay() {
const totalPay = this.sportsTourRoute.totalPrice * this.tourOrderData.personCount
return totalPay / 100
},
advancePay() {
const totalPay = this.sportsTourRoute.totalPrice * this.tourOrderData.personCount
return (totalPay * this.sportsTourRoute.advancePayRate) / 10000
},
hasAttn() {
if (this.tourOrderData.contactInfo.id) {
return true
}
if (this.attn.id) {
this.tourOrderData.contactInfo = this.attn
return true
}
return false
},
},
methods: {
...mapMutations({
saveTourOrderData: 'SAVE_TOUR_ORDER_DATA',
}),

...mapActions(['fetchUserCommonAttnByUserId', 'fetchSportsTourRouteById', 'fetchBasicConfig', 'showToast']),
mutateOrder() {
const { routeId } = this.$route.params
const self = this
self.tourOrderData.tourId = routeId
self.saveTourOrderData(self.tourOrderData)
},
goToAttn(type, attnId) {
const query = { from: 'tourOrder' }
if (attnId) {
query.id = attnId
} else {
query.type = 'attn'
}
this.mutateOrder()
this.$router.push({
name: `attn-${type}`,
query,
})
},
formateDate(timestamp) {
const date = new Date(timestamp)
const year = date.getFullYear()
const month = date.getMonth() + 1
const day = date.getDate()
return `${year}-${month}-${day}`
},
submitOrder() {
const self = this
const { routeId } = this.$route.params
const { userId } = this.$jwt
const { name, mobile } = this.tourOrderData.contactInfo

if (!name) {
this.showToast({
content: '请输入联系人姓名',
})
return false
}

if (isValid('number', name)) {
this.showToast({
content: '联系人填写有误，请检查！',
size: '15em',
})
return false
}

if (!mobile) {
this.showToast({
content: '请输入联系人手机号码',
size: '15em',
})
return false
}

if (!isValid('mobile', mobile)) {
this.showToast({
content: '手机号码填写有误，请输入11位国内手机号码！',
size: '21em',
})
return false
}

if (Number(self.tourOrderData.personCount) !== Number(this.sleletedTravelers.length)) {
this.showToast({
content: `请选择${self.tourOrderData.personCount}位出行人`,
size: '18em',
})
return false
}

for (let i = 0; i < this.sleletedTravelers.length; i += 1) {
this.travelers.push(this.sleletedTravelers[i].id)
}

const startTime = this.sportsTourRoute.startTimes[window.sessionStorage.getItem(`${this.userId + window.sessionStorage.getItem('routeId')}startTime`)].replace(/\./g, '-')
const req = {
personCount: self.tourOrderData.personCount,
contactInfo: {
name,
mobile,
},
packageTourRouteId: +routeId,
userId,
startTime: new Date(startTime).getTime(),
travelers: this.travelers,
}

showLoading()
return this.$http.post('/api/tourOrder', req).then(res => res.json())
.then((order) => {
closeLoading()
self.$router.push({
name: 'travel-order-pay',
query: {
orderId: order.id,
type: 'tour',
},
})
})
.catch((err) => {
closeLoading()
self.showToast({
content: err.body.resultInfo,
})
})
},
chat() {
window._MEIQIA('showPanel') 
},
selecttime() {
if (this.timeselectdivshow) {
this.timeselectdivshow = false
this.$refs.timearrow.src = '/static/images/icons/arrowdown.png'
} else {
this.timeselectdivshow = true
this.$refs.timearrow.src = '/static/images/icons/arrowup.png'
}
},
xiangqing() {
window.location.href = `/h5/sportsTourRouteIntroduction_detail/${this.sportsTourRoute.id}`
},
showCard(cardtype) {
for (let i = 0; i < this.sportsTourRoute.certificateType.length; i += 1) {
if (cardtype === this.sportsTourRoute.certificateType[i]) {
return true
}
}
return false
},
gotoAddPeople() {
window.sessionStorage.setItem(`${this.userId + window.sessionStorage.getItem('routeId')}personCount`, this.tourOrderData.personCount)

const { userId } = this.$jwt
const { personCount } = this.tourOrderData
const { certificateType } = this.sportsTourRoute
this.$router.push({ name: 'sports-tourPackage-addPeople', params: { userId, personCount, certificateType: certificateType.join('-') } })
},
timetabclick(id) {
for (let i = 0; i < document.getElementsByName('timeselectref').length; i += 1) {
document.getElementsByName('timeselectref')[i].style.color = '#858484'
document.getElementsByName('timeselectref')[i].style.backgroundColor = '#FFFFFF'
document.getElementsByName('timeselectref')[i].style.border = '#DADADA'
document.getElementsByName('timeselectref')[i].className = 'timeselect'
}

document.getElementsByName('timeselectref')[id].style.color = '#00C0C1'
document.getElementsByName('timeselectref')[id].style.backgroundColor = '#E5FFFF'
document.getElementsByName('timeselectref')[id].className = 'timeselect_blue'
document.getElementById('startTime').innerText = this.formattime(this.sportsTourRoute.startTimes[id])
window.sessionStorage.setItem(`${this.userId + window.sessionStorage.getItem('routeId')}startTime`, id)
},
deletepeopleicon(e) {
if (e.currentTarget.childNodes[0].getAttribute('check') === 'true') {
e.currentTarget.childNodes[0].setAttribute('check', 'false')
e.currentTarget.childNodes[0].src = '/static/images/icons/delete_icon.png'
e.currentTarget.parentNode.childNodes[4].style.display = 'block'
} else {
e.currentTarget.childNodes[0].setAttribute('check', 'true')
e.currentTarget.childNodes[0].src = '/static/images/icons/delete.png'
e.currentTarget.parentNode.childNodes[4].style.display = 'none'
}
},
deletepeople(id) {
this.sleletedTravelers_new = []
for (let j = 0; j < this.sleletedTravelers.length; j += 1) {
if (this.sleletedTravelers[j].id !== id) {
this.sleletedTravelers_new.push(this.sleletedTravelers[j])
}
}
this.sleletedTravelers = this.sleletedTravelers_new
window.sessionStorage.setItem(`${this.userId + window.sessionStorage.getItem('routeId')}sleletedTravelers`, JSON.stringify(this.sleletedTravelers))
},
formattime(time) {
const times = time.split('.')
return `${times[0]}年${times[1]}月${times[2]}日`
},
},
mounted() {
document.body.scrollTop = 0
},
created() {
window.sessionStorage.setItem('routeId', this.$route.params.routeId)

if (window.sessionStorage.getItem(`${this.userId + window.sessionStorage.getItem('routeId')}sleletedTravelers`) != null) {
const sleletedTravelers = window.sessionStorage.getItem(`${this.userId + window.sessionStorage.getItem('routeId')}sleletedTravelers`)
this.sleletedTravelers = JSON.parse(sleletedTravelers)
console.log(this.sleletedTravelers)
}

document.title = '确认预订'
meiqia.init(null, meiqia.travelGroupToken)
const { routeId } = this.$route.params

this.fetchUserCommonAttnByUserId(this.$jwt.userId)
this.fetchSportsTourRouteById({
routeId,
}).then(() => {
if (+routeId !== +this.tourOrderData.tourId) {
this.saveTourOrderData(this.initTourOrderData)
}
if (window.sessionStorage.getItem(`${this.userId + window.sessionStorage.getItem('routeId')}personCount`) != null) {
this.tourOrderData.personCount = window.sessionStorage.getItem(`${this.userId + window.sessionStorage.getItem('routeId')}personCount`)
}
})
},
}



// WEBPACK FOOTER //
// ./client/components/SportsTour/SportsTourPackageConfirm2.vue